import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import LdsTile from "../components/LdsTile";
// import LdsStepIndicator from "../components/LdsStepIndicator";
import LdsButton from "../components/LdsButton";
import LdsIcon from "../components/LdsIcon";

// services
import {
  useGetUserModuleQuery,
  useResumeTrainingMutation,
} from "../store/services/moduleServerApi";

const Overview = () => {
  const navigate = useNavigate();
  const [skipGetUserModuleQuery, setSkipGetUserModuleQuery] = useState(false);

  const [
    resumeTraining,
    { status, data: { data: { lastLockedSlide = "/" } = {} } = {} },
  ] = useResumeTrainingMutation();
  if (status === "fulfilled") {
    navigate(lastLockedSlide);
  }

  const { data: { data = [] } = {} } = useGetUserModuleQuery(null, {
    skip: !sessionStorage.getItem("token") || skipGetUserModuleQuery,
  });
  console.log("data :>> ", data);
  const isActivePointerEventForModule2 = data.some(
    ({ module, completed }) => ~~module === 1 && completed
  );
  const isActivePointerEventForModule3 = data.some(
    ({ module, completed }) => ~~module === 2 && completed
  );
  const isActivePointerEventForModule4 = data.some(
    ({ module, completed }) => ~~module === 3 && completed
  );
  const isActivePointerEventForModule5 = data.some(
    ({ module, completed }) => ~~module === 4 && completed
  );

  console.log(
    "isActivePointerEventForModule2, isActivePointerEventForModule3 :>> ",
    isActivePointerEventForModule2,
    isActivePointerEventForModule3
  );

  const handleModuleTraining = (moduleNo) => {
    setSkipGetUserModuleQuery(true);
    resumeTraining(moduleNo);
  };

  const [
    module1Response,
    module2Response,
    module3Response,
    module4Response,
    module5Response,
  ] = data;

  const { module: module1, completed: completed1 } = module1Response || {};
  const { module: module2, completed: completed2 } = module2Response || {};
  const { module: module3, completed: completed3 } = module3Response || {};
  const { module: module4, completed: completed4 } = module4Response || {};
  const { module: module5, completed: completed5 } = module5Response || {};

  return (
    <main>
      <section className="section">
        <div className="row">
          <div className="col-sm-12 col-md-8 offset-md-2">
            <h1 className="blue text-uppercase b mt-5 mb-4">
              Amyvid Training Overview
            </h1>
            <p className="me-4 d-inline-block b">2-3 Hours</p>
            <p className="me-4 d-inline-block b">English</p>
            <p className="me-4 d-inline-block b">MIM Referring Required</p>
            <h2 className="h3 b mt-4">In this course</h2>
            <p>
              <ul>
                <li>
                  The core Amyvid Reader Training program is primarily designed
                  to enhance your proficiency in interpreting Amyvid scans. It
                  consists of modules 1 through 3, with the specific focus of
                  each module described on-screen. All 3 modules must be
                  completed to receive certification.
                </li>
                <li>
                  Please note: Amyvid Reader Training must be completed in
                  sequential order. After you complete each module, the next
                  will become available. Completed modules can be revisited at
                  any time. The entire Core Reader Training program will take
                  approximately 2 to 3 hours to complete.
                </li>
                <li>
                  After you have completed Module 3, there are additional scans
                  for added training.
                </li>
              </ul>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-8 offset-md-2 mt-5">
            <div className="row">
              <div className="col-sm-12 d-flex">
                <div style={{ display: 'flex', width: '10%', flexDirection: 'column' }}>
                  <ul className="stepped-progress vertical overview">
                    <li className={`boxed ${module1 && completed1 ? "complete" : "current"}`} />
                    <li className={`boxed ${module2 && completed2 ? "complete" : "current"}`} />
                    <li className={`boxed ${module3 && completed3 ? "complete" : "current"}`} />
                    <li className={`boxed ${module4 && completed4 ? "complete" : "current"}`} />
                    <li className={`boxed ${module5 && completed5 ? "complete" : "current"}`} />
                  </ul>
                </div>

                <div class="overview-wrapper" style={{ display: 'flex', width: '90%', flexDirection: 'column' }}>
                  <LdsTile ariaLabel="Step 3" className="p-4 mb-4" role="region">
                    <LdsTile.Body className="row">
                      <h2 className="h4 b">Module 1</h2>
                      <p>
                        Learn about Alzheimer's disease (AD), its underlying
                        neuropathology, and the role of Amyvid
                      </p>
                      <p>
                        <span className="b fz-large me-2">4 Sections</span>
                      </p>
                      <LdsButton
                        linkButton
                        classes="mt-5 ms-3"
                        onClick={() => handleModuleTraining(1)}
                        style={{ textAlign: 'left' }}
                      >
                        Go to Module 1
                        <LdsIcon name="arrow-right" inline className="ms-1" />
                      </LdsButton>
                    </LdsTile.Body>
                  </LdsTile>

                  <LdsTile
                    ariaLabel="Step 3"
                    className={`p-4 mb-4 ${isActivePointerEventForModule2 === false
                      ? " disable-pointer-events"
                      : ""
                      }`}
                    role="region"
                  >
                    <LdsTile.Body className="row">
                      <h2 className="h4 b">Module 2</h2>
                      <p>
                        Learn the key anatomy, steps, and interpretation criteria
                        for Amyvid PET images
                      </p>
                      <p>
                        <span className="b fz-large me-2">3 Sections</span>
                      </p>
                      <LdsButton
                        linkButton
                        classes="mt-5 text-align-left ms-3"
                        onClick={() => handleModuleTraining(2)}
                        style={{ textAlign: 'left' }}
                      >
                        Go to Module 2
                        <LdsIcon name="arrow-right" inline className="ms-1" />
                      </LdsButton>
                    </LdsTile.Body>
                  </LdsTile>

                  <LdsTile
                    ariaLabel="Step 3"
                    className={`p-4 mb-4 ${isActivePointerEventForModule3 === false
                      ? " disable-pointer-events"
                      : ""
                      }`}
                    role="region"
                  >
                    <LdsTile.Body className="row">
                      <h2 className="h4 b">Module 3</h2>
                      <p>Put your knowledge to the test with real case studies</p>
                      <p>
                        <span className="b fz-large me-2">20 Case studies</span>
                      </p>

                      <LdsButton
                        linkButton
                        classes="mt-5 ms-3"
                        onClick={() => handleModuleTraining(3)}
                        style={{ textAlign: 'left' }}
                      >
                        Go to Module 3
                        <LdsIcon name="arrow-right" inline className="ms-1" />
                      </LdsButton>
                    </LdsTile.Body>
                  </LdsTile>
                  <div className="row">
                    <div className="col-sm-12">
                      <LdsButton
                        disabled={!completed3}
                        classes="blue-button mt-3 mb-5"
                        onClick={() => navigate("/certificate")}
                      >
                        Get Your Certificate
                      </LdsButton>
                    </div>
                  </div>
                  <LdsTile
                    ariaLabel="Step 3"
                    className={`p-4 mb-4 ${isActivePointerEventForModule4 === false
                      ? " disable-pointer-events"
                      : ""
                      }`}
                    role="region"
                  >
                    <LdsTile.Body className="row">
                      <h2 className="h4 b">
                        Additional scans for review (optional)
                      </h2>
                      <p>Challenge yourself with more real case studies</p>
                      <p>
                        <span className="b fz-large">20 Case studies</span>
                      </p>
                      <LdsButton
                        linkButton
                        classes="mt-5 ms-3"
                        onClick={() => handleModuleTraining(4)}
                        style={{ textAlign: 'left' }}
                      >
                        Additional Scans for Review
                        <LdsIcon name="arrow-right" inline className="ms-1" />
                      </LdsButton>
                    </LdsTile.Body>
                  </LdsTile>

                  <LdsTile
                    ariaLabel="Step 3"
                    className={`p-4 mb-4 ${isActivePointerEventForModule5 === false
                      ? " disable-pointer-events"
                      : ""
                      }`}
                    role="region"
                  >
                    <LdsTile.Body className="row">
                      <h2 className="h4 b">Reporting Module (optional)</h2>
                      <p>
                        Learn about recommended practices in reporting and sharing
                        scan results
                      </p>
                      <p>
                        <span className="b fz-large">5 Sections</span>
                      </p>
                      <LdsButton
                        linkButton
                        classes="mt-5 ms-3"
                        onClick={() => handleModuleTraining(5)}
                        style={{ textAlign: 'left' }}
                      >
                        Go to Reporting Module
                        <LdsIcon name="arrow-right" inline className="ms-1" />
                      </LdsButton>
                    </LdsTile.Body>
                  </LdsTile>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Overview;
